// extracted by mini-css-extract-plugin
export default {"paletteWrapper":"colorPalette_paletteWrapper__sgkd9","paletteList":"colorPalette_paletteList__BGs8v"};